@if (candidates && candidates.length > 0) {
  <rt-group [class.stacked]="true" [class.horizontal]="true" class="group" margin-left-small-xxx>
    @for (candidate of candidates | slice: 0 : 3; track trackByCandidate($index, candidate)) {
      @if (candidate.isAnonymous) {
        <rt-avatar
          [shape]="'oval'"
          size="small"
          type="icon"
          iconName="visibility-off"
          customIconBackgroundColor="colorAvatarSteelLighter"
        ></rt-avatar>
      } @else {
        <rt-avatar
          [type]="candidate.hasAvatar ? 'image' : 'initials'"
          [imageSrc]="candidate.photoThumbUrl"
          [initials]="candidate.initials"
          [context]="'candidate'"
          size="small"
          class="background-automated-actions-assistant"
        >
        </rt-avatar>
      }
    }
    @if (candidates.length > 3) {
      <div class="more-indicator">
        <rt-icon name="more-horiz" colorToken="colorIconDefault"></rt-icon>
      </div>
    }
  </rt-group>
}
